import React from "react";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Bar } from "react-chartjs-2";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// @material-ui/icons components

// core components

import { chartOptions, parseOptions, chartExample2 } from "variables/charts.js";

import componentStyles from "assets/theme/components/cards/charts/card-total-orders.js";

const useStyles = makeStyles(componentStyles);

function CardTotalOrders(props) {
  const classes = useStyles();
  const theme = useTheme();

  const themeColors = require("assets/theme/colors.js").default;

  if(props.stats == null || props.stats == undefined){
    props.stats = [];
  } 

  let currency = localStorage.getItem("selectedCountry") == 2 ? "SAR" : "BHD";

  let chartConfig = {
    options: {
      scales: {
        yAxes: [
          {
            gridLines: {
              color: themeColors.gray[700],
              zeroLineColor: themeColors.gray[700],
            },
            ticks: {
              callback: function (value) {
                if (!(value % 10)) {
                  return value;
                }
              },
            },
          },
        ],
      },
      tooltips: {
        callbacks: {
          label: function (item, data) {
            var label = data.datasets[item.datasetIndex].label || "";
            var yLabel = item.yLabel;
            var content = "";
  
            if (data.datasets.length > 1) {
              content += label;
            }
  
            content += "" + yLabel + " "+currency;
            return content;
          },
        },
      },
    },
    data: () => {
      return {
        labels: props.stats.map(function(stat, idx) {
          return stat.month.replace(' ','');
      }),
        datasets: [
          {
            label: "Performance",
            data: props.stats.map(function(stat, idx) {
              return stat.amount.toFixed(3);
          }),
          },
        ],
      };
    }
  };

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }
  return (
    <>
      <Card classes={{ root: classes.cardRoot }}>
        <CardHeader
          title={
            <Box component="span" color={theme.palette.gray[600]}>
              Performane
            </Box>
          }
          subheader="Sales value"
          classes={{ root: classes.cardHeaderRoot }}
          titleTypographyProps={{
            component: Box,
            variant: "h6",
            letterSpacing: "2px",
            marginBottom: "0!important",
            classes: {
              root: classes.textUppercase,
            },
          }}
          subheaderTypographyProps={{
            component: Box,
            variant: "h3",
            marginBottom: "0!important",
            color: "initial",
          }}
        ></CardHeader>
        <CardContent>
          <Box position="relative" height="390px">
            <Bar data={chartConfig.data} options={chartExample2.options} />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default CardTotalOrders;
